import { useContext, useEffect, useState } from "react";
import { GetRequest } from "../../utils/ApiServices";
import { GlobalContext } from "../../context/GlobalState";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function BecomeAMember() {
  const [showModal, setShowModal] = useState(false);
  const [MembershipData, setMembershipData] = useState([]);
  const fetchData = async () => {
    const res = await GetRequest("membership-plans");
    setMembershipData(res);
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div
      className="section section-padding-02"
      style={{ marginBottom: "30px", marginTop: "-20px" }}
    >
      <div className="container">
        {/* Call to Action Wrapper Start */}
        <div className="call-to-action-wrapper" style={{ width: "100%" }}>
          <img
            className="cat-shape-01 animation-round"
            src={process.env.PUBLIC_URL + "/images/shape/shape-12.png"}
          />
          <img
            className="cat-shape-02"
            src={process.env.PUBLIC_URL + "/images/shape/shape-13.svg"}
          />
          <img
            className="cat-shape-03 animation-round"
            src={process.env.PUBLIC_URL + "/images/shape/shape-12.png"}
          />
          <div className="row align-items-center">
            <div className="col-md-6">
              {/* Section Title Start */}
              <div className="section-title shape-02">
                <h5 className="sub-title">Become a Member </h5>
                <h2 className="main-title">
                  Join as a member and get full Access!
                </h2>
              </div>
              {/* Section Title End */}
            </div>
            <div className="col-md-6">
              <div className="call-to-action-btn">
                <div
                  className="btn btn-primary btn-hover-dark"
                  onClick={() => setShowModal(true)}
                  // onClick={handleShow}
                >
                  Join Now
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Call to Action Wrapper End */}
      </div>
      {showModal && (
        <ProductModal
          setShowModal={setShowModal}
          MembershipData={MembershipData}
        />
      )}
    </div>
  );
}

function ProductModal({ setShowModal, MembershipData }) {
  const { singleCartState, singlecartDispatch } = useContext(GlobalContext);
  const navigate = useNavigate();
  const handleBuy = (course) => {
    if (
      Array.isArray(singleCartState?.cart) &&
      singleCartState?.cart?.some((item) => item.id === course?.id)
    ) {
      toast.error("This membership is already in your cart.", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
      return;
    }
    //checks for enrolment
    //if this course is asking for enrolments
    if (course?.ask_enrolment_quantity === true) {
      //check  if user provided any quantity
      const enrolment_quantity = parseInt(
        document.getElementById("input-enrolment-quantity").value
      );

      if (enrolment_quantity > 0) {
        course.enrolment_quantity = enrolment_quantity;
      } else {
        document
          .getElementById("input-enrolment-quantity")
          .scrollIntoView({ behavior: "smooth", block: "center" });
        document
          .getElementById("input-enrolment-quantity")
          .focus({ preventScroll: true });
        setTimeout(() => {
          window.alert("Please enter number of enrolments.");
        }, 1000);
        return;
      }
    }
    singlecartDispatch({ type: "ADD_TO_CART", payload: course });
    //window.location.replace('https://codefrontend.com');
    navigate("/cart");
  };
  return (
    <div className="modal show d-block" tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Choose Your Membership</h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => setShowModal(false)}
            ></button>
          </div>
          <div className="modal-body d-flex justify-content-between">
            {MembershipData.map((dt, i) => (
              <div className="card" key={i} style={{ width: "50%" }}>
                <div className="card-body">
                  <h5 className="card-title">{dt?.course_name}</h5>
                  <p className="card-text text-danger">AED {dt?.price}</p>
                  <button
                    className="btn btn-success"
                    onClick={() => handleBuy(dt)}
                  >
                    Buy
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BecomeAMember;
